import { SEO } from "@components/SEO/SEO"
import React from "react"

import DownloadTemplate from "@templates/download"
import { useSiteMetadata } from "@hooks/use-site-metadata"
import { texts } from "@data/downloads"

const Telechargements = ({ location }) => {
  const { lang } = useSiteMetadata()

  return <DownloadTemplate lang={lang} />
}

export default Telechargements

export const Head = ({ location, params, data, pageContext }) => {
  return (
    <SEO
      pathname={location.pathname}
      title={texts["fr"].seo_title}
      description={texts["fr"].seo_description}
    />
  )
}
